import { AxiosResponse } from 'axios'
import { Moment } from 'moment'

import ClientSDK from '../../../../App/ClientSDK'
import { DATE_STANDARD_FORMAT } from '../../../../App/DateFormats'

import {
    IAPIEmployeeReference,
    IEmployeeReferenceStatistics,
} from './IEmployeeReference'
import Transformer from './Transformer'

export class Client {
    static getEmployeeReference = (
        from: Moment,
        to: Moment
    ): Promise<IEmployeeReferenceStatistics> => {
        const startAt = from.format(DATE_STANDARD_FORMAT)
        const endsAt = to.format(DATE_STANDARD_FORMAT)

        return ClientSDK.instance()
            .get(`reports/person-performance/${startAt}/${endsAt}`)
            .then(
                (
                    response: AxiosResponse<IAPIEmployeeReference>
                ): IEmployeeReferenceStatistics[] => {
                    return Transformer.transform(response.data.statistics)
                }
            )
    }
}
